// extracted by mini-css-extract-plugin
export default {"roleCard":"role_card-module___roleCard___e8cac2b9"};